module.exports = __webpack_public_path__ + "img/img_logo.d0a429a9.png";